// nodeTypes.js
import CustomNodeComponent from './CustomNodeComponent';

export const nodeTypes = {
  customNode: CustomNodeComponent,
};